import { atom } from 'recoil';

export type marketplaceTabs = 'buy' | 'listings' | 'offers' | 'history' | 'inventory';

export const marketplaceTabAtom = atom({ key: 'marketplaceTabAtom', default: 'buy' as marketplaceTabs });
